import { PricingImpactPreviewDialog } from './PricingImpactPreviewDialog';
import type { PricingConfigurationFormProps } from './pricingConfigurationFormProps';
import type { usePricingPreviewFlow } from './usePricingPreviewFlow';

/** „Wirkung prüfen“ am Formular: Zustand aus dem Ablauf, Gründe und Neuladen aus der Seite. */
export function ConfigurationPreview({
  flow,
  props,
}: {
  flow: ReturnType<typeof usePricingPreviewFlow>;
  props: PricingConfigurationFormProps;
}) {
  const { onReload } = props;
  return (
    <PricingImpactPreviewDialog
      open={flow.dialogOpen}
      apartmentName={props.apartmentName}
      mode={flow.previewInput?.mode ?? flow.values.mode}
      currency={flow.previewInput?.currency ?? props.configuration.currency}
      nextVersion={props.versionNumber + 1}
      horizonDays={props.configuration.horizonDays}
      preview={flow.freshPreview}
      loading={Boolean(props.previewing || props.checking)}
      saving={flow.submitting || Boolean(props.saving)}
      failed={Boolean(props.dialogProblem)}
      activationFailed={Boolean(props.dialogProblem?.activation)}
      failure={props.dialogProblem?.text}
      retryable={props.dialogProblem?.retryable ?? true}
      reloadable={Boolean(onReload)}
      ownershipAdoption={flow.ownershipAdoption}
      returnFocusRef={flow.returnFocusRef}
      onOpenChange={flow.setDialogOpen}
      onOwnershipAdoptionChange={flow.setOwnershipAdoption}
      onRetry={() => void flow.runPreview()}
      onConfirm={() => void flow.confirm()}
      // Der neue Stand ersetzt den Entwurf; die Seite sagt das (useConfigurationReset).
      onReload={
        onReload &&
        (() => {
          flow.setDialogOpen(false);
          onReload();
        })
      }
    />
  );
}
